import { LetsBonkToken } from '@sodamnfoolish/sjc-backend-types/src/api/bonk/dto';
import { PumpFunToken } from '@sodamnfoolish/sjc-backend-types/src/api/pump/dto';

export type SortOrder = 'ASC' | 'DESC';

export type Sorter<T extends {}> = (a: T, b: T) => number;

export function createPumpFunTokensSorter<SortBy extends keyof PumpFunToken>(
    sortBy: SortBy,
    order: SortOrder = 'ASC',
    map: (key: PumpFunToken[SortBy]) => number,
): Sorter<PumpFunToken> {
    return (a, b) => {
        if (!a || !b) {
            return 0; // Handle null values gracefully
        }

        const valueA = map(a[sortBy]);
        const valueB = map(b[sortBy]);

        return order === 'ASC' ? valueA - valueB : valueB - valueA;
    };
}

export function createBonkTokensSorter<SortBy extends keyof LetsBonkToken>(
    sortBy: SortBy,
    order: SortOrder = 'ASC',
    map: (key: LetsBonkToken[SortBy]) => number,
): Sorter<LetsBonkToken> {
    return (a, b) => {
        if (!a || !b) {
            return 0; // Handle null values gracefully
        }

        const valueA = map(a[sortBy]);
        const valueB = map(b[sortBy]);

        return order === 'ASC' ? valueA - valueB : valueB - valueA;
    };
}
